export const VerificationType = {
	EMAIL: 'EMAIL',
	PHONE: 'PHONE',
};
